import { Observable } from 'rxjs';
import { ITermCondition } from 'src/app/models/parameters/ITermCondition';

export abstract class ITermConditionsService {
    abstract getTermsConditions(): Observable<ITermCondition[]>;
    abstract getTermConditionByLanguage(): Observable<ITermCondition[]>;
}
